import React, { useState, useEffect } from "react";
import { Link, Navigate, useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers,faTachometer, faTasks, faEye, faPencil, faTrashCan, faVideo, faArrowLeft, faDumbbell, faCheckCircle, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import { useRecoilState } from 'recoil';
import ReactPlayer from 'react-player/lazy'

import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../../../../AppState";
import { getSessionDetailAPI, putSessionUpdateAPI } from "../../../../../API/Session";
import { getSelectedOptions } from "../../../../../Helpers/selectHelper";
import useLocalStorage from "../../../../../Hooks/useLocalStorage";
import DataDisplayRowText from "../../../../Reusable/DataDisplayRowText";
import PageLoadingContent from "../../../../Reusable/PageLoadingContent";


function UserSessionVideoSectionExerciseDetail() {
    ////
    //// URL parameters.
    ////

    const { uid, sid, vsid, eid } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user, setUser] = useRecoilState(userDetailState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [session, setSession] = useLocalStorage(sid, "");
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [showDeletionConfirmationModal, setShowDeletionConfirmationModal] = useState(false);

    ////
    //// API.
    ////

    // --- Detail --- //

    function onSessionDetailSuccess(response){
        console.log("onSessionDetailSuccess: Starting...");
        setSession(response);
    }

    function onSessionDetailError(apiErr) {
        console.log("onSessionDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionDetailDone() {
        console.log("onSessionDetailDone: Starting...");
        setFetching(false);
    }

    // --- Update --- //

    function onSessionUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Session updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        setShowDeletionConfirmationModal(false);
        setForceURL("/user/" + uid + "/session/" + sid + "/video-section/" + vsid + "/exercises");
    }

    function onSessionUpdateError(apiErr) {
        console.log("onSessionUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionUpdateError: Delayed for 2 seconds.");
            console.log("onSessionUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionUpdateDone() {
        console.log("onSessionUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick"); // For debugging purposes only.

        const videoSection = session.videoSections[vsid];
        const { exercises } = videoSection;
        console.log(exercises);
        const selectedExerciseForDeletion = exercises[eid];

        console.log("selectedExerciseForDeletion:", selectedExerciseForDeletion);

        //
        // The following code will remove the data from the JSON.
        //

        let eIndex;
        for (let exerciseIndex in videoSection.exercises) {
            let ex = videoSection.exercises[exerciseIndex];
            if (ex.name === selectedExerciseForDeletion.name) {
                console.log(ex);
                eIndex = exerciseIndex;
                break;
            }
        }

        console.log("videoSectionIndex:", eIndex);
        videoSection.exercises.splice(eIndex, 1);

        // Update the session.
        console.log("onSubmitClick, session:", session);
        putSessionUpdateAPI(session, onSessionUpdateSuccess, onSessionUpdateError, onSessionUpdateDone);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionDetailAPI(
                sid,
                onSessionDetailSuccess,
                onSessionDetailError,
                onSessionDetailDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    const videoSection = session.videoSections[vsid];
    const { exercises } = videoSection;
    console.log(exercises);
    const exercise = exercises[eid];

    // SPECIAL THANKS TO: https://stackoverflow.com/a/9851769
    // Safari 3.0+ "[object HTMLReusableConstructor]"
    let isSafari = /constructor/i.test(window.HTMLReusable) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    // Redirect user if necessary.
    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Sessions)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Video Sections)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercises`} aria-current="page"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercises</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercise</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercises`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Exercises</Link></li>
                        </ul>
                    </nav>

                    {/* Modals */}
                    <nav class="">
                        <div class={`modal ${showDeletionConfirmationModal ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={(e, ses) => setShowDeletionConfirmationModal(false)}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this exercise and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={(e, ses) => setShowDeletionConfirmationModal(false)}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>

                    {/* Page */}
                    <nav class="box">

                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercise - {user.firstName} {user.lastName}</p>
                                <p class="subtitle is-6"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eid}/edit`} class="button is-small is-warning is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit Exercise
                                </Link>
                                &nbsp;
                                <button onClick={(e, ses) => setShowDeletionConfirmationModal(true)} class="button is-small is-danger is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faTrashCan} />&nbsp;Delete Exercise
                                </button>
                            </div>
                        </div>

                        {!isSafari &&
                            <article class="message is-warning pt-0">
                              <div class="message-body">
                                Your web browser may not support the <i>m3u8 file format</i> so you'll need to download an accompanying plugin to view the video content. Here is the recommended plugin for Chrome Web browser:
                                <br/><br/>
                                - <b><a href="https://chrome.google.com/webstore/detail/native-hls-playback/emnphkkblegpebimobpbekeedfgemhof">Native HLS Playback&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b>
                              </div>
                            </article>
                        }

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                {exercise !== undefined && exercise !== null && exercise !== "" && <div class="container">
                                    <DataDisplayRowText
                                        label="Name"
                                        value={exercise.name}
                                    />
                                    <DataDisplayRowText
                                        label="Type"
                                        value={exercise.type}
                                    />
                                    <DataDisplayRowText
                                        label="Duration"
                                        value={exercise.duration}
                                    />

                                    <div class="field pb-4">
                                        <label class="label">Preview Image</label>
                                        <div class="control">
                                            {exercise.previewImageUrl
                                                ? <>
                                                    <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                        <img src={exercise.previewImageUrl} alt="Preview Image URL" />
                                                    </div>
                                                </>
                                                : <>
                                                    <p>-</p>
                                                </>
                                            }
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label class="label">Preview (Deprecated)</label>
                                        <div class="control">
                                            {exercise.previewUrl
                                                ? <>
                                                    {!isSafari
                                                    ? <>
                                                        <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                            <br />
                                                            View video by <b><a href={exercise.previewUrl} target="_blank" rel="noreferrer">clicking here&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b> to open in new tab. <br />
                                                            <br />
                                                        </div>
                                                    </>
                                                    : <>
                                                        <div className="p-3 has-background-black box" style={{borderRadius: "20px"}}>
                                                            <video width="100%" height="100%" controls>
                                                                 <source src={exercise.previewUrl} type="application/x-mpegURL" />
                                                            </video>
                                                        </div>
                                                    </>
                                                    }
                                                </>
                                                : <p>Not ready</p>
                                            }
                                        </div>
                                        <br />
                                    </div>

                                    <DataDisplayRowText
                                        label="Preview Description"
                                        type="textlist"
                                        value={exercise.previewDescription}
                                    />

                                    <DataDisplayRowText
                                        label="Rest Upcoming Name (Optional)"
                                        value={exercise.restUpcomingName}
                                    />

                                    <div class="field pb-4">
                                        <label class="label">Video</label>
                                        <div class="control">
                                            {exercise.videoUrl
                                                ? <>
                                                    {!isSafari
                                                    ? <>
                                                        <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                            <br />
                                                            View video by <b><a href={exercise.videoUrl} target="_blank" rel="noreferrer">clicking here&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b> to open in new tab. <br />
                                                            <br />
                                                        </div>
                                                    </>
                                                    : <>
                                                        <div className="p-3 has-background-black box" style={{borderRadius: "20px"}}>
                                                            <video width="100%" height="100%" controls>
                                                                 <source src={exercise.videoUrl} type="application/x-mpegURL" />
                                                            </video>
                                                        </div>
                                                    </>
                                                    }
                                                </>
                                                : <p>Not ready</p>
                                            }
                                        </div>
                                        <br />

                                    </div>

                                    <div class="columns">
                                        <div class="column is-half">
                                            <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercises`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                        </div>
                                        <div class="column is-half has-text-right">
                                            <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eid}/edit`} class="button is-warning is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Edit</Link>
                                        </div>
                                    </div>

                                </div>}
                            </>
                        }
                    </nav>
                </section>
            </div>
        </>
    );
}

export default UserSessionVideoSectionExerciseDetail;
